import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { images } from '../data/site';
const ease = [0.22, 1, 0.36, 1];
export function Hero() {
  return <section className="relative overflow-hidden px-4 pt-28 sm:px-6 sm:pt-32" data-id="element-73" data-mp="9kjxsrx55a59">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-74" data-mp="9igwhbqjful8">
        <div className="animate-drift absolute -left-32 top-10 h-[36rem] w-[36rem] rounded-full bg-champagne/20 blur-[130px]" data-id="element-75" data-mp="4njpeactjvaz" />
        <div className="animate-drift-slow absolute -right-24 top-64 h-[32rem] w-[32rem] rounded-full bg-taupe/25 blur-[140px]" data-id="element-76" data-mp="xae8p3xwgomv" />
        <div className="animate-drift absolute left-1/3 top-[28rem] h-[26rem] w-[26rem] rounded-full bg-sage/10 blur-[130px]" data-id="element-77" data-mp="sai2qz5n6n4o" />
      </div>

      <div className="relative mx-auto grid max-w-[92rem] items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-78" data-mp="nbyhz22sbhdw">
        <motion.div initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.6,
        ease
      }} className="order-2 overflow-hidden rounded-[2rem] border border-charcoal/[0.07] bg-ivorydeep lg:order-1" data-id="element-79" data-mp="3czfkfwx3o34z">
          <img src={images.portraitDesk} alt="Amoye Henry, founder, operator and investor" className="h-full w-full object-cover" data-id="element-80" data-mp="3o73q0dt77y94" />
        </motion.div>

        <div className="order-1 lg:order-2 lg:pl-4" data-id="element-81" data-mp="3e7uzjuxjl1ri">
          <motion.p initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease
        }} className="eyebrow text-mocha" data-id="element-82" data-mp="30hhnphhj52ww">
            Founder · Operator · Investor · Strategist
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 26
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.1,
          ease
        }} className="mt-7 font-serif text-[3.25rem] font-light leading-[0.95] tracking-[-0.015em] text-charcoal sm:text-[4.75rem] xl:text-[5.75rem]" data-id="element-83" data-mp="2viomanfip2d3">
            Building companies
            <br className="hidden sm:block" data-id="element-84" data-mp="s3cloaja7jqk" /> that move industries
            <br className="hidden sm:block" data-id="element-85" data-mp="na9zingu3cke" />{' '}
            <span className="italic text-mocha" data-id="element-86" data-mp="n9i3jbjbrctl">forward.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 26
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease
        }} className="mt-9 max-w-lg text-[1.0625rem] leading-[1.75] text-charcoal/65" data-id="element-87" data-mp="ia5jeyju8jup">
            I build companies, support founders, shape ecosystems, and help
            ambitious organisations unlock transformational growth across Africa
            and global markets.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 26
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease
        }} className="mt-11 flex flex-wrap items-center gap-3" data-id="element-88" data-mp="x0cu2s3lsyku">
            <Button to="/contact" data-id="element-89" data-mp="1x9b5n20k33d3">Work with me</Button>
            <Button to="/investments" variant="secondary" data-id="element-90" data-mp="1xavz0ob4wg9d">
              View portfolio
            </Button>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1.2,
          delay: 0.5,
          ease
        }} className="mt-14 font-script text-[2rem] leading-none text-mocha/80" data-id="element-91" data-mp="218jv3uokcf2u">
            Amoye
          </motion.p>
        </div>
      </div>
    </section>;
}